import React, { Component } from 'react'
import get from 'lodash/get'

import { PrintTemplate } from '@fielded/shared-ui'

import { getPlannedQuantities, makeDeliveryItems, makeDeliveryItemsV2 } from '../subapps/shipments/common/makeDeliveryItems'
import { getReceivedSnapshotComment, getSentSnapshotComment } from '../subapps/shipments/common/utils'
import { hasFeature } from '../van-shared/utils/features'
import withConfig from '../van-shared/hoc/withConfig'

import DeliveryStatementDeliveryInfo from './DeliveryStatementDeliveryInfo'
import ShipmentContentsTablePSM from '../subapps/shipments/components/ShipmentContentsTablePSM'
import { formatDate } from '../van-shared/utils/utils'

class DeliveryStatementPSM extends Component {
  render () {
    const {
      config,
      shipment,
      paymentType,
      location,
      productsById,
      batchesById,
      productPricesById
    } = this.props

    const date = get(shipment, 'snapshotDates.received', shipment.date)
    const formattedDate = formatDate(date, 'printShortWithTime')
    const country = get(location, 'location.country')
    const useShipmentPrices = hasFeature(config, 'features.useShipmentPrices')
    const makeItems = useShipmentPrices ? makeDeliveryItemsV2 : makeDeliveryItems

    const plannedQuantities = getPlannedQuantities(shipment)
    const items = makeItems({
      shipment,
      report: {},
      productsById,
      batchesById,
      includeReportItems: false,
      sortByName: true,
      plannedQuantities,
      config,
      productPricesById
    }) || []

    const receivedSnapshot = getReceivedSnapshotComment(shipment)
    const { comment, signedBy, signature, phoneNumber: receivedPhone } = receivedSnapshot || {}

    const sentSnapshot = getSentSnapshotComment(shipment)
    const {
      signedBy: packedBy,
      signature: packedSignature,
      phoneNumber: packedPhone
    } = sentSnapshot || {}

    const numItems = items.length

    const boxblock = (
      <DeliveryStatementDeliveryInfo
        numberOfItems={numItems}
        date={formattedDate}
        paymentType={paymentType}
      />
    )

    return (
      <PrintTemplate>
        <PrintTemplate.Header title='Delivery statement' config={config} />
        <PrintTemplate.Box
          left={boxblock}
          right={<div className='delivery-statement-info'><div><strong className='delivery-statement-info__header'>{location.fullName}</strong></div>{location.additionalData.physicalAddress}</div>}
        />
        <PrintTemplate.Section>
          <div className='print-template__delivery'>Delivery No. {shipment.shipmentNo}</div>
        </PrintTemplate.Section>
        <PrintTemplate.Section withOverflow>
          <ShipmentContentsTablePSM
            items={items}
            country={country}
            withDetailsPopup
            withBatch
            withIcon
            withDetailedColumns
          />
        </PrintTemplate.Section>
        <PrintTemplate.Section>
          Delivery confirmed on <strong>{formattedDate}</strong>
        </PrintTemplate.Section>
        {comment &&
        <PrintTemplate.Section>
          <strong>Comment:</strong> {comment}
        </PrintTemplate.Section>
        }
        <PrintTemplate.Section>
          <div className='delivery-statement-signatures'>
            <div className='delivery-statement-signatures__block'>
              {packedSignature && (
                <div className='signature-display vs-u-margin-top-tripple'>
                  <img alt='signature' src={packedSignature} />
                </div>
              )}
              <div><strong>Packed by: {packedBy || 'N/A'}</strong></div>
              <div>Warehouse Manager</div>
              <div>{packedPhone || 'N/A'}</div>
            </div>
            <div className='delivery-statement-signatures__block delivery-statement-signatures__block--right'>
              {signature && (
                <div className='signature-display vs-u-margin-top-tripple'>
                  <img alt='signature' src={signature} />
                </div>
              )}
              <div><strong>Received by: {signedBy || 'N/A'}</strong></div>
              <div>Facility Authorised Staff</div>
              <div>{receivedPhone || 'N/A'}</div>
            </div>
          </div>
        </PrintTemplate.Section>
      </PrintTemplate>
    )
  }
}

export default withConfig(DeliveryStatementPSM)
